<template>

  <a class="movie-card"
	:href="screening.movie.link"
	:style="{ 'grid-area': screeningToGridAreaString }">
	<div class="img-wrapper">
		<img :src="thumbnailUrl">
	</div>
	<div class="details">
		<h2 class="movie-title" v-html="screening.movie.title.rendered"></h2>
		<h3 class="movie-duration">
			{{ (lang=='he-IL'? 'אורך ':'Duration ') + screening.movie['custom_fields'].duration.trim() }}
		</h3>
		<h2 class="movie-time">{{ screening.time }}</h2>
		<div class="buttons-wrapper">
			<a :href="screening.movie.link">
              {{ lang=='he-IL'? 'קראו עוד':'Read more' }}
			</a>
			<a :href="screening.link_to_by" target="_blank">
              {{ lang=='he-IL'? 'כרטיסים':'Tickets' }}
			</a>
		</div>
	</div>
  </a><!-- .card -->

</template>

<script>
export default {
	props: {
		screening: {
			type: Object,
			required: true,
			default: null
		},
		searchTerm: {
			type: String,
			required: false,
			default: ''
		},
		minHour: {
			type: Number,
			required: true,
			default: 11
		},
		hoursAmount: {
			type: Number,
			required: true,
			default: 15
		},
		placeToColumnMap: {
			type: Object,
			required: true
		},
		placesMapLoaded: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			screeningToGridAreaString: '',
			lang: 'he-IL'
		}
	},
	methods: {
		convertTime12To24(time12h) {
			const [time, modifier] = time12h.split(' ');
			let [hours, minutes] = time.split(':');
			if (hours === '12') hours = '00';
			if (modifier === 'pm') hours = parseInt(hours, 10) + 12;
			return `${hours}:${minutes}`;
		},
		convertTime12ToNumber(time12h) {
			const [time, modifier] = time12h.split(' ');
			let [hours, minutes] = time.split(':');
			if (hours === '12') hours = 0;
			if (modifier === 'pm') hours = parseInt(hours, 10) + 12;
			if (hours === 0) hours = 24;
			return Number(hours)+(minutes/60);
		},
		convertTime24ToNumber(time24h) {
			const [time, modifier] = time24h.split(' ');
			let [hours, minutes] = time.split(':');
			if (hours == 0) hours+=24
			minutes = Math.floor(minutes/15)*15;
			return Number(hours)+(minutes/60);
		},
	},
	mounted() {
		let time = this.convertTime24ToNumber(this.screening.time)
		let place = this.screening.where
		let row = (time*4)-(this.minHour*4)+2
		let column = this.placeToColumnMap[place]
		let durationText = this.screening.movie['custom_fields'].duration
		if (!durationText) durationText = "60"
		let lengthInMinutes = durationText.match(/\d+/)[0]
		let spanLength = Math.round(lengthInMinutes/15) || 1
		this.screeningToGridAreaString = `${row} / ${column} / span ${spanLength}`
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	},
	computed: {
		thumbnailUrl() {
			if (!this.screening.movie.featured_image_url) return ''
			return this.screening.movie.featured_image_url
		}
	}
};
</script>

<style scoped>
.movie-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 300px;
	width: 100%;
	justify-self: center;
	cursor: pointer;
}

.movie-card .img-wrapper {
	border-bottom: 1px solid black;
	overflow: hidden;
}

.movie-card .img-wrapper img {
	width: 100%;
	transform: scale(1);
	transition: 300ms ease-in-out;
}
.movie-card:hover .img-wrapper img {
	transform: scale(1.05);
}

.movie-card .details {
	position: relative;
	width: 100%;
	padding-top: 5px;
	display: flex;
	flex-direction: column;
	gap: 1em;
	overflow: hidden;
	flex-grow: 1;
}

.details .movie-title,
.details .movie-duration {
	font-size: 1em;
	text-align: center;
	margin: 0;
	padding: 0;
}

.details .movie-duration {
	font-weight: 400;
}

.details .movie-time {
	font-size: 1.3em;
	color: var(--pink);
	text-align: center;
	margin: 0;
	padding: 0;
}

.buttons-wrapper {
	position: absolute;
	top: 100%;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	opacity: 0;
	transition: 300ms ease-in-out;
}

.movie-card:hover .details .buttons-wrapper {
	top: 0;
	opacity: 1;
}

/* on tablets or smaller screens */
@media only screen and (max-width: 768px) {
	.movie-card .details .buttons-wrapper {
		top: 0;
		opacity: 1;
	}
}

.movie-card .buttons-wrapper a {
	height: 51%;
	width: 100%;
	text-align: center;
	border: none;
	background-color: white;
	color: black;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.movie-card .buttons-wrapper a:nth-child(2) {
	color: white;
	background-color: black;
}

.movie-card .buttons-wrapper a:hover {
	bottom: 0;
	font-size: 1.05em;
}


</style>

